// Import files here. This is the main lib entry point.
// You can use ES5, or ES6 here.
import $ from "jquery";
const jQuery = $;

$(document).on("click", 'a[rel$="external"]', function () {
    $(this).attr("target", "_blank");
});

$(document).on("click", 'a[href$=".pdf"]', function () {
    $(this).attr("target", "_blank");
});

$("a").each(function () {
    var a = new RegExp("/" + window.location.host + "/");
    if (!a.test(this.href)) {
        $(this).click(function (event) {
            event.preventDefault();
            event.stopPropagation();
            window.open(this.href, "_blank");
        });
    }
});

jQuery.fn.extend({
    live: function (event, callback) {
        if (this.selector) {
            jQuery(document).on(event, this.selector, callback);
        }
    },
});

$(".nav-links").click(function (e) {
    anchorScroll(
        $(this),
        $($(this).attr("href")),
        1200,
        $("#header").get(0).getBoundingClientRect().height
    );
});

function anchorScroll(this_obj, that_obj, base_speed, offset) {
    var this_offset = this_obj.offset();
    var that_offset = that_obj.offset();
    var offset_diff = Math.abs(that_offset.top - this_offset.top);

    var speed = (offset_diff * base_speed) / 2000;

    $("html,body").animate(
        {
            scrollTop: that_offset.top - offset,
        },
        speed
    );
}

$('[data-element-name="content"] img.remdiv').unwrap("p");

//DISALBES form submit on enter
$("#searchform").on("keyup keypress", function (e) {
    var keyCode = e.keyCode || e.which;
    if (keyCode === 13) {
        e.preventDefault();
        return false;
    }
});

//adds new window label for screen readers

$("a[target='_blank']").each(function (e) {
    var el = $(this);
    if (el.text() !== "") {
        el.attr("aria-label", el.text() + " - New Window");
    }
});

$("p").each(function () {
    var $this = $(this);
    if ($this.html().replace(/\s|&nbsp;/g, "").length == 0) $this.remove();
});

$(document).ready(function () {
    $("#bs4navbar .nav-link").click(function (e) {
        if (!!e.originalEvent) {
            if (e.originalEvent instanceof MouseEvent) {
                var url = $(this).attr("href");
                $(location).attr("href", url);
            }
        }
    });

    (function () {
        var timeout;
        var $window = $(window);
        var $navbar = $('#dynamicheader');

        $window.on('scroll', function (e) {
            clearTimeout(timeout);

            timeout = setTimeout(function () {
                if ($window.scrollTop() < 100) {
                    $navbar.removeClass('hide');
                } else {
                    $navbar.addClass('hide');
                }
            }, 100);
        });
    }());



    $('[data-id="contact-method"]').addClass('col-12 col-md-6 col-lg-12 col-xl-6 mb-4 mb-xl-0');













});



$(document).ready(function () {
    function isInViewport(element) {
        const rect = element.getBoundingClientRect();
        const elementHeight = rect.height || element.offsetHeight;

        // Check if the element's midpoint is within the viewport
        return (
            rect.top + elementHeight / 3 < window.innerHeight && // Element's midpoint enters the viewport
            rect.bottom - elementHeight / 3 > 0 // Element's midpoint is not fully out of view
        );
    }

    function checkVisibility() {
        $('.copy-right').each(function () {
            if (isInViewport(this)) {
                $(this).addClass('slide-in-right');
            }
        });

        $('.copy-left').each(function () {
            if (isInViewport(this)) {
                $(this).addClass('slide-in-left');
            }
        });
    }

    // Run the check on scroll and page load
    $(window).on('scroll', checkVisibility);
    checkVisibility(); // Initial check in case the element is already in view
});